module.exports = "#map, #mapid {\n  width: 100%;\n  height: 100%;\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/map/map.component.scss
// module id = ./src/app/shared/components/map/map.component.scss
// module chunks = main